// Helper to persist & detect SDK iframe mode (app_type=skor-sdk)
// Single source of truth – use this everywhere instead of ad-hoc localStorage checks.

const SDK_KEY = "skor-sdk";
const STORAGE_KEY = "app_type";
const STORAGE_EXPIRY_KEY = "app_type_expires_at";
const SDK_TTL_MS = 60 * 60 * 1000; // 1 hour

export const getAppTypeFromSearch = (search = window.location.search) => {
  try {
    const params = new URLSearchParams(search);
    return params.get("app_type") || params.get("appType") || null;
  } catch {
    return null;
  }
};

export const isSkorSdkSearch = (search = window.location.search) =>
  getAppTypeFromSearch(search) === SDK_KEY;

export const isSkorSdkMode = (search) => {
  if (typeof window === "undefined") return false;
  const activeSearch =
    typeof search === "string" ? search : window.location.search;
  if (isSkorSdkSearch(activeSearch)) return true;
  if (localStorage.getItem(STORAGE_KEY) !== SDK_KEY) return false;
  const expiresAt = localStorage.getItem(STORAGE_EXPIRY_KEY);
  if (!expiresAt) {
    // legacy entry without expiry — treat as expired
    clearSkorSdkMode();
    return false;
  }
  if (Date.now() > Number(expiresAt)) {
    clearSkorSdkMode();
    return false;
  }
  return true;
};

// Persist SDK flag from current URL → localStorage. Call on every navigation.
export const persistSkorSdkFromUrl = (search = window.location.search) => {
  if (isSkorSdkSearch(search)) {
    localStorage.setItem(STORAGE_KEY, SDK_KEY);
    localStorage.setItem(STORAGE_EXPIRY_KEY, String(Date.now() + SDK_TTL_MS));
    return true;
  }
  return false;
};

export const clearSkorSdkMode = () => {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(STORAGE_EXPIRY_KEY);
};

// Keep the embedded choice separate from the main app's shared localStorage.
const SDK_LANGUAGE_KEY = "skor_sdk_language";
export const getSdkLanguage = () => {
  try {
    return sessionStorage.getItem(SDK_LANGUAGE_KEY) || "es";
  } catch {
    return "es";
  }
};

export const isSdkLangExplicit = () => {
  try {
    return sessionStorage.getItem(SDK_LANGUAGE_KEY) === "1";
  } catch {
    return false;
  }
};

export const rememberSdkLanguage = (language) => {
  if (!isSkorSdkMode()) return;
  try {
    sessionStorage.setItem(SDK_LANGUAGE_KEY, language);
  } catch {
    // The current page still changes language when storage is unavailable.
  }
};

export const markSdkLangExplicit = () => {
  try {
    sessionStorage.setItem(SDK_LANGUAGE_KEY, "1");
  } catch {
    // storage unavailable — the Spanish default still applies
  }
};

export const getInitialLanguage = (fallback = "es") =>
  isSkorSdkMode()
    ? getSdkLanguage()
    : localStorage.getItem("i18nextLng")?.toLowerCase() || fallback;
